import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { IPageData, UIError } from 'common/interfaces';
import { IShiftReport, IShiftReportReview, IShiftReportState } from 'common/interfaces/ishiftReport';

const initialStoreState: IShiftReportState = {
  loading: false,
  error: undefined,
  shiftReports: undefined,
  ongoingShiftReport: undefined,
  nonApprovedShiftReports: undefined,
  reportReviews: undefined,
};

const reducers = {
  setLoading: (state: IShiftReportState, action: PayloadAction<boolean>) => {
    state.loading = action.payload;
  },
  setError: (state: IShiftReportState, action: PayloadAction<UIError | null>) => {
    state.error = action.payload;
  },
  resetContext: (state: IShiftReportState) => {
    state = initialStoreState;
  },

  setShiftReports: (
    state: IShiftReportState,
    action: PayloadAction<{
      data: IPageData<IShiftReport> | undefined;
      append: boolean;
    }>,
  ) => {
    if (!action.payload.append) {
      state.shiftReports = action.payload.data;
    } else if (action.payload.data) {
      const stReports = state.shiftReports?.items || [];
      const playloadItems = action.payload.data?.items || [];
      state.shiftReports = {
        ...action.payload.data,
        items: [...stReports, ...playloadItems],
      };
    }
  },
  setOngoingShiftReport: (state: IShiftReportState, action: PayloadAction<IShiftReport | undefined>) => {
    state.ongoingShiftReport = action.payload;
  },
  setNonApprovedShiftReports: (
    state: IShiftReportState,
    action: PayloadAction<{
      data: IPageData<IShiftReport> | undefined;
      append: boolean;
    }>,
  ) => {
    if (!action.payload.append) {
      state.nonApprovedShiftReports = action.payload.data;
    } else if (action.payload.data) {
      const stReports = state.nonApprovedShiftReports?.items || [];
      const playloadItems = action.payload.data?.items || [];
      state.nonApprovedShiftReports = {
        ...action.payload.data,
        items: [...stReports, ...playloadItems],
      };
    }
  },
  setShiftReportReviews: (state: IShiftReportState, action: PayloadAction<IShiftReportReview[] | undefined | null>) => {
    state.reportReviews = action.payload;
  },
};

const shiftReportSlice = createSlice({
  name: 'IShiftReportState',
  initialState: initialStoreState,
  reducers: reducers,
});

export default shiftReportSlice.reducer;
export const ShiftReportActions = shiftReportSlice.actions;
